import { render, staticRenderFns } from "./ScoreDapsa.vue?vue&type=template&id=2d711294&scoped=true"
import script from "./ScoreDapsa.vue?vue&type=script&lang=js"
export * from "./ScoreDapsa.vue?vue&type=script&lang=js"
import style0 from "./ScoreDapsa.vue?vue&type=style&index=0&id=2d711294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d711294",
  null
  
)

export default component.exports